import type { ThemeTokens } from "@yamada-ui/core"

export const blurs: ThemeTokens = {
  sm: "4px",
  md: "8px",
  lg: "12px",
  xl: "16px",
  "2xl": "24px",
}
